import { createContext as t, useContext as o } from "react";
const n = {
  locale: "pt-BR"
}, e = t(n), a = () => o(e);
export {
  e as TranslationContext,
  a as useTranslationContext
};
